export default "<div class=\"redirect\">\n    <app-header></app-header>\n\n</div>\n\n";